// extracted by mini-css-extract-plugin
module.exports = {"title":"mobileLinks_title___9N6D","link":"mobileLinks_link__Edyw_"};